import { ReactElement, useEffect } from "react";
import store from "../../../_services/store";
import { BackButton } from "../../_ui";
import quizztext from '../../../_translations/quizz.json';
import { getQuizzQuestions } from "../../../_services/api/quizz";
import { observer } from "mobx-react";
import { Label } from "./components";
import QuizzImage from "./quizz-image/quizz-image";
import QuizzQuestions from "./quizz-questions/quizz-questions";
import QuizzFillblank from "./quizz-fillblank/quizz-fillblank";
import QuizzFindGoodImage from "./quizz-find-good-image/quizz-find-good-image";

const Quizz = observer(() => {
  const { quizzId } = store;

  useEffect(() => {
    console.log("-- LOAD quiz details for ID: ", quizzId);
    getQuizzQuestions({ id: quizzId, lg: store.currentLanguage }).then(
      (res) => {
        console.log("quizz from api", res);

        store.setCurrentQuestion({ id: 0, data: res[0] });
        store.setQuestionIndex(0);
        store.setResQuiz(res);
      }
    );
    return () => { };
  }, []);

  if (store.quizzes === null || store.currentQuestion === null) {
    return <p>No Quizzes or no questions, should not happen</p>;
  }

  const currentQuestion = store.currentQuestion.data;
  if (!currentQuestion) return <></>;

  const currentQuizzType = currentQuestion.type;
  const title = store.quizzes.quizPercentageResult.find(e => e.quiz_id === store.quizzId)?.quiz_name;
  const subTitle = quizztext[store.currentLanguage].labels.quizzesSubtitles[currentQuizzType];

  let CurrentQuizzElement: ReactElement = <></>;
  switch (currentQuizzType) {
    case "1": // image drop quizz
      CurrentQuizzElement = <QuizzImage />
      break;
    case "2":
      CurrentQuizzElement = <QuizzQuestions />
      break;
    case "3":
      CurrentQuizzElement = <QuizzFillblank />
      break;
    case "4":
      CurrentQuizzElement = <QuizzFindGoodImage />
      break;
    default:
      break;
  }

  return (
    <div className="fadeIn">
      <BackButton title={title || "error"} />
      <div style={{display: 'flex', justifyContent:'center'}}>
        <Label style={{margin: '0 auto'}}>{subTitle}</Label>
      </div>
      <div style={{paddingBottom: '120px'}} >
        {currentQuizzType && CurrentQuizzElement}
        </div>
    </div>
  )
})

export default Quizz;